/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or
  substantial portions of the Software.

*/

import React from 'react';

// nodejs library to set properties for components
import PropTypes from 'prop-types';
// reactstrap components
import {
  Container, Row, Col
} from 'reactstrap';

// Account config
import config from 'config';

function AuthHeader() {
  return (
    <div className="header bg-info py-7 py-lg-8 pt-lg-9">
      <Container className="mt-4">
        <Row>
          <Col className="collapse-brand text-center" lg="12">
            <img
              alt="..."
              src={config.assets.img.brand['logo-white']}
              style={{
                position: 'relative',
                top: -100,
                maxWidth: '80%'
              }}
            />
          </Col>
        </Row>
      </Container>
      <div className="separator separator-bottom separator-skew zindex-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon className="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
  );
}

export default AuthHeader;
